import { Porcentajes_anteproy } from './../../../models/porcentajes_anteproy.model';
import { Component, ViewChild,  TemplateRef } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material/dialog';
declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-porcentajes_anteproy",
    templateUrl: "./porcentajes_anteproy.component.html",
    styleUrls: ["./porcentajes_anteproy.component.css"],
    providers: [FormService]
})
export class Porcentajes_anteproyComponent {
    @ViewChild('openModal') openModal:TemplateRef<any>;
      public rows = [];
      public actualRow;
      public porcentajes_anteproy: Porcentajes_anteproy;
      public form;
      public number;

    
 
     public matcher = new FormService();

    constructor(private fb: FormBuilder, private dialog: MatDialog){
    

        this.number = localStorage.getItem("form");
        console.log(this.number)

        this.form = new FormGroup({
            sup_predios: new FormControl(''),
            porc_predios:new FormControl(''),
            cant_predios :new FormControl(''),
            sup_areas: new FormControl(''),
            porc_areas:new FormControl(''),
            cant_areas :new FormControl(''),
            sup_equip: new FormControl(''),
            porc_equip:new FormControl(''),
            cant_equip :new FormControl(''),
            sup_valid :new FormControl(''),
            porc_valid :new FormControl(''),
            cant_valid :new FormControl(''),
            sup_reserva :new FormControl(''),
            porc_reserva :new FormControl(''),
            cant_reserva :new FormControl('')
            
        })

        if(!JSON.parse(localStorage.getItem("porcentajes_anteproy"))){
            localStorage.setItem("porcentajes_anteproy", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("porcentajes_anteproy"));
            this.form.controls['sup_predios'].setValue(this.rows[0]?this.rows[0].sup_predios:'')
            this.form.controls['porc_predios'].setValue(this.rows[0]?this.rows[0].porc_predios:'')
            this.form.controls['cant_predios'].setValue(this.rows[0]?this.rows[0].cant_predios:'')
            this.form.controls['sup_areas'].setValue(this.rows[0]?this.rows[0].sup_areas:'')
            this.form.controls['porc_areas'].setValue(this.rows[0]?this.rows[0].porc_areas:'')
            this.form.controls['cant_areas'].setValue(this.rows[0]?this.rows[0].cant_areas:'')
            this.form.controls['sup_equip'].setValue(this.rows[0]?this.rows[0].sup_equip:'')
            this.form.controls['porc_equip'].setValue(this.rows[0]?this.rows[0].porc_equip:'')
            this.form.controls['cant_equip'].setValue(this.rows[0]?this.rows[0].cant_equip:'')
            this.form.controls['sup_valid'].setValue(this.rows[0]?this.rows[0].sup_valid:'')
            this.form.controls['porc_valid'].setValue(this.rows[0]?this.rows[0].porc_valid:'')
            this.form.controls['cant_valid'].setValue(this.rows[0]?this.rows[0].cant_valid:'')
            this.form.controls['sup_reserva'].setValue(this.rows[0]?this.rows[0].sup_reserva:'')
            this.form.controls['porc_reserva'].setValue(this.rows[0]?this.rows[0].porc_reserva:'')
            this.form.controls['cant_reserva'].setValue(this.rows[0]?this.rows[0].cant_reserva:'')
        }
      
        this.porcentajes_anteproy = {sup_predios:'',porc_predios:'',cant_predios:'',sup_areas:'',porc_areas:'',cant_areas:'',sup_equip:'',porc_equip:'',cant_equip:'',sup_valid:'',porc_valid:'',cant_valid:'',sup_reserva:'',porc_reserva:'',cant_reserva:''};
       

    }
 
    add_porcentajes_anteproy(){
        localStorage.setItem("porcentajes_anteproy",JSON.stringify([]));
        this.actualRow = localStorage.getItem("porcentajes_anteproy");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            sup_predios: this.form.value.sup_predios,
            porc_predios: this.form.value.porc_predios,
            cant_predios: this.form.value.cant_predios,
            sup_areas: this.form.value.sup_areas,
            porc_areas: this.form.value.porc_areas,
            cant_areas: this.form.value.cant_areas,
            sup_equip: this.form.value.sup_equip,
            porc_equip: this.form.value.porc_equip,
            cant_equip: this.form.value.cant_equip,
            sup_valid: this.form.value.sup_valid,
            porc_valid: this.form.value.porc_valid,
            cant_valid: this.form.value.cant_valid,
            sup_reserva: this.form.value.sup_reserva,
            porc_reserva: this.form.value.porc_reserva,
            cant_reserva: this.form.value.cant_reserva         
            
        })
        localStorage.setItem("porcentajes_anteproy", JSON.stringify(this.rows));
        

    }
    delete_porcentajes_anteproy(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("porcentajes_anteproy", JSON.stringify(this.rows));
            }
        }
    }

   

}